// extracted by mini-css-extract-plugin
export var documentation = "_kt-1";
export var menu = "_kt-0";